export const MeetingAgendaTemplate = {
  type: 'doc',
  content: [
    {
      type: 'heading',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
        level: 1,
      },
      content: [
        {
          type: 'text',
          text: 'Agenda',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
          ],
          text: '(This template is based on a standard board meeting agenda format. Please revise accordingly to suit your needs.)',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: 0,
        nodeTextAlignment: '',
        nodeLineHeight: '2.4',
        style: '',
      },
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: 0,
        nodeTextAlignment: '',
        nodeLineHeight: '2.4',
        style: '',
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Welcome - <Speaker> - <Duration>',
        },
      ],
    },
    {
      type: 'orderedList',
      attrs: {
        order: 1,
      },
      content: [
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  text: 'Opening remarks ',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  text: 'Attendance ',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  text: 'Approval of agenda',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  text: '… ',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Review of previous minutes - <Speaker> - <Duration>',
        },
      ],
    },
    {
      type: 'orderedList',
      attrs: {
        order: 1,
      },
      content: [
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Approve/edit previous meeting minutes',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Actions taken since previous meeting',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: '...',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Reports & operational metrics - <Speaker> - <Duration>',
        },
      ],
    },
    {
      type: 'orderedList',
      attrs: {
        order: 1,
      },
      content: [
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Report 1',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Report 2',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Report 3',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: '… ',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Old business - <Speaker> - <Duration>',
        },
      ],
    },
    {
      type: 'orderedList',
      attrs: {
        order: 1,
      },
      content: [
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Point 1',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Point 2',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: '… ',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'New business - <Speaker> - <Duration>',
        },
      ],
    },
    {
      type: 'orderedList',
      attrs: {
        order: 1,
      },
      content: [
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Point 1',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Point 2',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: '… ',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Other business - <Speaker> - <Duration>',
        },
      ],
    },
    {
      type: 'orderedList',
      attrs: {
        order: 1,
      },
      content: [
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Point 1',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: 'Point 2',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          attrs: {
            closed: false,
            nested: false,
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: 0,
                nodeTextAlignment: '',
                nodeLineHeight: '2.4',
                style: '',
              },
              content: [
                {
                  type: 'text',
                  text: '… ',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: {
                nodeIndent: null,
                nodeTextAlignment: null,
                nodeLineHeight: null,
                style: '',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Adjournment - <Speaker> - <Duration>',
        },
      ],
    },
  ],
};
